export { default } from './PasswordReset'



// WEBPACK FOOTER //
// ./src/pages/PasswordReset/index.js